import { StoreOrderBy } from "@/libs/bounce/bounceSdk.types.gen"
import type { StoreOrderByTagProps } from "@/screens/LuggageStorage/CityListViewScreen/components/OrderSelector/CityListViewOrderSelector"

export const DEFAULT_ORDER_BY_KEY: StoreOrderByTagProps = "relevance"
export const ORDER_BY_OPTIONS: StoreOrderByTagProps[] = ["relevance", "rating"]
export const ORDER_BY_MAPPING = {
  relevance: StoreOrderBy.Relevance,
  rating: StoreOrderBy.Rating,
}

export const DEFAULT_ORDER_BY = ORDER_BY_MAPPING[DEFAULT_ORDER_BY_KEY]
